<div class="palette" role="region" aria-label="Node Palette">
  <header class="palette__header">
    <h2 class="palette__title">Node Palette</h2>
    <button
      mat-button
      type="button"
      class="palette__collapse"
      (click)="toggleCollapsed()"
      [attr.aria-expanded]="!collapsed()"
      aria-controls="connect-node-palette-content"
    >
      {{ collapsed() ? 'Expand' : 'Minimize' }}
    </button>
  </header>

  @if (!collapsed()) {
    <mat-form-field appearance="outline" class="palette__search">
      <mat-label>Search nodes</mat-label>
      <input matInput type="text" placeholder="Search nodes..." [value]="query()" (input)="setQuery(($any($event.target).value || ''))" />
    </mat-form-field>
  }

  <div id="connect-node-palette-content" class="palette__content" [class.palette__content--hidden]="collapsed()">
    @for (category of categories; track category) {
      @if (itemsForCategory(category).length > 0) {
        <section class="palette__section">
          <div class="section__header">
            <p class="section__title">{{ category }}</p>
            <div class="section__actions">
              <span class="section__count" aria-label="{{ category }} count">{{ itemsForCategory(category).length }}</span>
              <button mat-button type="button" class="section__toggle" [attr.aria-label]="'Toggle ' + category" (click)="toggleCategory(category)">
                {{ isCategoryExpanded(category) ? 'Hide' : 'Show' }}
              </button>
            </div>
          </div>

          @if (isCategoryExpanded(category)) {
            <div class="section__body">
              @if (category === 'Integrations' && providerGroups().length > 0) {
                <div class="providers">
                  @for (group of providerGroups(); track group.providerId) {
                    <div class="provider">
                      <button
                        type="button"
                        class="provider__header"
                        (click)="toggleProvider(group.providerId)"
                        [attr.aria-expanded]="isProviderExpanded(group.providerId)"
                      >
                        @if (group.provider?.logo) {
                          <img
                            class="provider__logo"
                            [src]="group.provider?.logo"
                            [alt]="(group.provider?.name || group.providerId) + ' logo'"
                            loading="lazy"
                          />
                        }
                        <span class="provider__name">{{ group.provider?.name || group.providerId }}</span>
                        @if (group.provider?.palette?.background || group.provider?.palette?.border) {
                          <span
                            class="provider__dot"
                            aria-hidden="true"
                            [style.backgroundColor]="group.provider?.palette?.background || null"
                            [style.borderColor]="group.provider?.palette?.border || null"
                          ></span>
                        }
                        <span class="provider__count">{{ group.items.length }} {{ group.items.length === 1 ? 'node' : 'nodes' }}</span>
                      </button>

                      @if (group.provider?.description) {
                        <p class="provider__description">{{ group.provider?.description }}</p>
                      }

                      @if (isProviderExpanded(group.providerId)) {
                        <div class="provider__items">
                          @for (item of group.items; track item.paletteId) {
                            <ng-diagram-palette-item class="node" [item]="item.diagramItem">
                              <div class="node__card">
                                <div class="node__row">
                                  @if (item.diagramItem.data.providerLogo) {
                                    <img class="node__logo" [src]="item.diagramItem.data.providerLogo" [alt]="item.diagramItem.data.providerName || 'Provider'" loading="lazy" />
                                  }
                                  <span class="node__label">{{ item.label }}</span>
                                </div>
                                @if (item.description) {
                                  <p class="node__description">{{ item.description }}</p>
                                }
                              </div>
                              <ng-diagram-palette-item-preview>
                                <div class="node__preview">
                                  <span class="node__label">{{ item.label }}</span>
                                </div>
                              </ng-diagram-palette-item-preview>
                            </ng-diagram-palette-item>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }

              <div class="nodes">
                @for (item of visibleUngroupedItemsForCategory(category); track item.paletteId) {
                  <ng-diagram-palette-item class="node" [item]="item.diagramItem">
                    <div class="node__card">
                      <div class="node__row">
                        @if (item.diagramItem.data.providerLogo) {
                          <img class="node__logo" [src]="item.diagramItem.data.providerLogo" [alt]="item.diagramItem.data.providerName || 'Provider'" loading="lazy" />
                        }
                        <span class="node__label">{{ item.label }}</span>
                      </div>
                      @if (item.description) {
                        <p class="node__description">{{ item.description }}</p>
                      }
                    </div>
                    <ng-diagram-palette-item-preview>
                      <div class="node__preview">
                        <span class="node__label">{{ item.label }}</span>
                      </div>
                    </ng-diagram-palette-item-preview>
                  </ng-diagram-palette-item>
                }

                @if (query().trim().length === 0 && ungroupedItemsForCategory(category).length > 20 && !showAll()[category]) {
                  <button mat-stroked-button type="button" class="pager" (click)="setShowAll(category, true)">
                    Show more ({{ ungroupedItemsForCategory(category).length - 20 }})
                  </button>
                }

                @if (query().trim().length === 0 && ungroupedItemsForCategory(category).length > 20 && showAll()[category]) {
                  <button mat-stroked-button type="button" class="pager" (click)="setShowAll(category, false)">
                    Show less
                  </button>
                }
              </div>
            </div>
          }
        </section>
      }
    }

    @if (totalMatches() === 0) {
      <p class="palette__empty">No results</p>
    }
  </div>
</div>

